import { FREIGHT_TYPE } from '@schuettflix/interfaces';

export function isWasteFreightType(freightType?: FREIGHT_TYPE): boolean {
    return freightType === 'HAZARDOUS_WASTE' || freightType === 'NON_HAZARDOUS_WASTE';
}
